// 内部版本号 minor 位最大为 15, 第四位记录真实版本号
// eslint-disable-next-line import/no-mutable-exports
export let innerVersion = '4.15.00.1600'; // 仪表盘上报使用 https://tapd.woa.com/tapd_fe/20396022/story/detail/1020396022874739483
// 用于显示的三位的版本号
// eslint-disable-next-line import/no-mutable-exports
export let version = '5.0.0';
export function setVersion(v: string) {
  version = v;
  const [major, minor, patch] = v.split('.').map(x => parseInt(x, 10));
  innerVersion = `${major}.${Math.min(15, minor)}.${Math.min(15, patch)}.${minor.toString().padStart(2, '0')}${patch.toString().padStart(2, '0')}`;
}
export const IS_WORKER = typeof importScripts !== 'undefined';
export const IS_WORKLET = typeof registerProcessor !== 'undefined';
export const getScriptDir = () => {
  const x = IS_WORKER
    ? self.location.href
    : (document.currentScript as HTMLScriptElement).src;
  return x.substring(0, x.lastIndexOf('/') + 1);
};

export let loggerProxy = '';
export const setLoggerProxy = (domain: string) => (loggerProxy = domain);
export const BASE_HOST = 'web.sdk.qcloud.com';
export const SECOND_HOST = 'web.sdk.tencent.cn';
export const THIRD_HOST = 'web.sdk.cloud.tencent.cn';
export const CLOUD_CONSOLE_URL = 'https://console.cloud.tencent.com/trtc';
export const BASE_DOC_URL = `https://${BASE_HOST}/trtc/webrtc/doc`;
export const DOC_URL = `${BASE_DOC_URL}/zh-cn/`;
// 计费说明文档链接
export const DOC_BILLING_CN = 'https://cloud.tencent.com/document/product/647/85386';
export const DOC_BILLING_OVERSEA = 'https://trtc.io/document/56025';
export const LOGGER_DOMAIN = 'https://yun.tim.qq.com';
// export const LOGGER_DOMAIN = 'https://test.tim.qq.com';
export const LOGGER_DOMAIN_OVERSEA = 'https://apisgp.my-imcloud.com';
export const TRTC_ERROR_ASSISTANCE = 'trtc_error_assistance';
export const LOGGER_CMD_TYPE = {
  // 上报 kibana 日志
  LOG: 'jssdk_log',
  // 上报后台秒级监控
  EVENT: 'jssdk_event',
  // 上报罗盘统计关键路径数据
  KEY_POINT: 'jssdk_new_endreport',
  // KV 上报
  KV_STAT: 'jssdk_key_metrics_report'
} as const;
export const ENV_NAME = {
  // TRTC 线上环境
  QCLOUD: 'qcloud',
  // 旧云梯环境，目前只有呼叫中心使用
  OLD_CLOUD_LADDER: 'trtc',
  // 自研环境，目前电话 SDK、腾讯课堂在使用
  WEBRTC: 'webrtc'
} as const;
export enum LOG_LEVEL {
  /**
   * 输出所有日志
   */
  TRACE,
  /**
   * 输出 DEBUG、INFO、WARN、ERROR 等级日志
   */
  DEBUG,
  /**
   * 输出 INFO、WARN、ERROR 等级日志
   */
  INFO,
  /**
   * 输出 WARN、ERROR 等级日志
   */
  WARN,
  /**
   * 输出 ERROR 等级日志
   */
  ERROR,
  /**
   * 不输出任何日志
   */
  NONE,
}

// ping 超时时间，如果 ping 发出后，在指定时间内未收到 pong，则 ping 超时失败
export const SIGNAL_PING_TIMEOUT = 18000;
// 两次 ping pong 间隔
export const SIGNAL_PING_PONG_INTERVAL = 2000;

// 网络类型与仪表盘传参的对应关系
export const NETWORK_TYPE = {
  unknown: 0,
  wifi: 1,
  '4g': 2,
  '3g': 3,
  '2g': 4,
  wired: 5,
  '5g': 6
} as const;

// storage 数据有效期
export const STORAGE_EXPIRES_TIME = 7 * 24 * 3600 * 1000;

// the recommended profiles for audio
// 目前立体声支持： web <-> web, native -> web，不支持 web -> native（需要后台支持）
// 开放立体声 audio profile 配置，但是不在文档中暴露，等后台支持 web -> native 再考虑暴露。
export const audioProfileMap = {
  standard: { sampleRate: 48000, channelCount: 1, bitrate: 40 },
  'standard-stereo': { sampleRate: 48000, channelCount: 2, bitrate: 64 },
  high: { sampleRate: 48000, channelCount: 1, bitrate: 128 },
  'high-stereo': { sampleRate: 48000, channelCount: 2, bitrate: 192 }
} as const;

/*
 * | 视频Profile | 分辨率（宽 x 高）| 帧率（fps）| 码率（kbps）|
 * | :---       | :---           | :---      | :---      |
 * | 120p       | 160 x 120      | 15        | 200        |
 * | 180p       | 320 x 180      | 15        | 350        |
 * | 240p       | 320 x 240      | 15        | 400       |
 * | 360p       | 640 x 360      | 15        | 800       |
 * | 480p       | 640 x 480      | 15        | 900       |
 * | 720p       | 1280 x 720     | 15        | 1500      |
 * | 1080p      | 1920 x 1080    | 15        | 2000      |
 * | 1440p      | 2560 x 1440    | 30        | 4860      |
 * | 4K         | 3840 x 2160    | 30        | 9000      |
 */
export const videoProfileMap = {
  '120p': { width: 160, height: 120, frameRate: 15, bitrate: 200 },
  '120p_2': { width: 160, height: 120, frameRate: 15, bitrate: 100 },
  '180p': { width: 320, height: 180, frameRate: 15, bitrate: 350 },
  '180p_2': { width: 320, height: 180, frameRate: 15, bitrate: 150 },
  '240p': { width: 320, height: 240, frameRate: 15, bitrate: 400 },
  '240p_2': { width: 320, height: 240, frameRate: 15, bitrate: 200 },
  '360p': { width: 640, height: 360, frameRate: 15, bitrate: 800 },
  '360p_2': { width: 640, height: 360, frameRate: 15, bitrate: 400 },
  '480p': { width: 640, height: 480, frameRate: 15, bitrate: 900 },
  '480p_2': { width: 640, height: 480, frameRate: 15, bitrate: 500 },
  '720p': { width: 1280, height: 720, frameRate: 15, bitrate: 1500 },
  '1080p': { width: 1920, height: 1080, frameRate: 15, bitrate: 2000 },
  '1440p': { width: 2560, height: 1440, frameRate: 30, bitrate: 4860 },
  '4K': { width: 3840, height: 2160, frameRate: 30, bitrate: 9000 }
} as const;

export const defaultBigVideoProfile = videoProfileMap['480p_2'];
export const defaultSmallVideoProfile = videoProfileMap['120p_2'];

export const screenProfileMap = {
  '480p': { width: 640, height: 480, frameRate: 5, bitrate: 900 },
  '480p_2': { width: 640, height: 480, frameRate: 30, bitrate: 1000 },
  '720p': { width: 1280, height: 720, frameRate: 5, bitrate: 1200 },
  '720p_2': { width: 1280, height: 720, frameRate: 30, bitrate: 3000 },
  '1080p': { width: 1920, height: 1080, frameRate: 5, bitrate: 1600 },
  '1080p_2': { width: 1920, height: 1080, frameRate: 30, bitrate: 4000 },
  '1440p': { width: 2560, height: 1440, frameRate: 5, bitrate: 2000 },
  '1440p_2': { width: 2560, height: 1440, frameRate: 30, bitrate: 4860 },
  '4K': { width: 3840, height: 2160, frameRate: 5, bitrate: 4000 },
  '4K_2': { width: 3840, height: 2160, frameRate: 30, bitrate: 9000 }
} as const;

// 全局常用的字符名称
export const NAME = {
  CANVAS: 'canvas',
  AUDIO: 'audio',
  VIDEO: 'video',
  SCREEN: 'screen',
  SMALL: 'small',
  BIG: 'big',
  AUXILIARY: 'auxiliary',
  SMALL_VIDEO: 'smallVideo',
  FACING_MODE_USER: 'user',
  FACING_MODE_ENVIRONMENT: 'environment',
  MUTE: 'mute',
  UNMUTE: 'unmute',
  ENDED: 'ended',
  PLAYING: 'playing',
  PAUSE: 'pause',
  ERROR: 'error',
  LOADSTART: 'loadstart',
  LOADEDDATA: 'loadeddata',
  LOADEDMETADATA: 'loadedmetadata',
  AUDIO_INPUT: 'audioinput',
  VIDEO_INPUT: 'videoinput',
  DETAIL: 'detail',
  TEXT: 'text',
  MAIN: 'main',
  BACKUP: 'backup',
  BANNED: 'banned',
  KICK: 'kick',
  USER_TIME_OUT: 'user_time_out',
  ROOM_DISBAND: 'room_disband',
  SEI_MESSAGE: 'sei-message',
  ADD: 'add',
  REMOVE: 'remove',
  REPLACE: 'replace',
  TRACK: 'track',
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
  TRANSCEIVER_DIRECTION_SENDONLY: 'sendonly',
  TRANSCEIVER_DIRECTION_RECVONLY: 'recvonly',
  ENTER_PICTURE_IN_PICTURE: 'enterpictureinpicture',
  LEAVE_PICTURE_IN_PICTURE: 'leavepictureinpicture',
  FULLSCREEN_CHANGE: 'fullscreenchange',
  RESIZE: 'resize',
  TIME_UPDATE: 'timeupdate'
} as const;

export const TRANSPORT_DIRECTION: {
  INACTIVE: RTCRtpTransceiverDirection,
  SENDONLY: RTCRtpTransceiverDirection,
  RECVONLY: RTCRtpTransceiverDirection,
} = {
  INACTIVE: 'inactive',
  SENDONLY: 'sendonly',
  RECVONLY: 'recvonly'
};
export const BACKEND_ENV = {
  // 旧云梯环境，目前只有呼叫中心使用
  OLD_CLOUD_LADDER: 'wss://trtc.rtc.qq.com',
  // 自研环境，目前电话 SDK、腾讯课堂在使用
  WEBRTC: 'wss://webrtc.qq.com'
};

export const enum Scene {
  LIVE = 'live',
  RTC = 'rtc',
}
/**
 * downlink connection's muted flag defined by backend.
 */
export const VIDEO_STAT_BIT = 0x01;
export const SMALL_STAT_BIT = 0x02;
export const AUX_STAT_BIT = 0x04;
export const AUDIO_STAT_BIT = 0x08;
export const AUDIO_MUTE_BIT = 0x40;
export const VIDEO_MUTE_BIT = 0x10;
export const MUTE_ALL_BIT = 0x70;
export const CROSS_ROOM_BIT = 0x80;
export const DATA_CHANNEL_FROM_TYPE_BIT = 0x100;

/**
 * Stream MSID
 */
export const MAIN_STREAM_MSID = '5Y2wZK8nANNAoVw6dSAHVjNxrD1ObBM2kBPV';
export const AUX_STREAM_MSID = '224d130c-7b5c-415b-aaa2-79c2eb5a6df2';

export const REMOTE_STREAM_TYPE_MAIN = NAME.MAIN;
export const REMOTE_STREAM_TYPE_AUX = NAME.AUXILIARY;

export const TRTC_QUALITY_UNKNOWN = 0;
export const TRTC_QUALITY_EXCELLENT = 1;
export const TRTC_QUALITY_GOOD = 2;
export const TRTC_QUALITY_POOR = 3;
export const TRTC_QUALITY_BAD = 4;
export const TRTC_QUALITY_VERY_BAD = 5;
export const TRTC_QUALITY_DISCONNECTED = 6; // 上行连接断开、下行所有连接都断开

export const DTLS_STATE_UNKNOWN = 'unknown';

export const PEER_CONNECTION_STATE = {
  NEW: 'new',
  CONNECTING: 'connecting',
  FAILED: 'failed',
  CLOSED: 'closed',
  DISCONNECTED: 'disconnected',
  CONNECTED: 'connected',
  COMPLETED: 'completed'
};

// 推拉流重试次数、pc 断网重连重试次数
let retryCount = Infinity;

export function setRetryCount(count: number) {
  retryCount = count;
}
export function getRetryCount() {
  return retryCount;
}
export const SIGNAL_RECONNECTION_COUNT = 30;

export const KIBANA_EVENT = {
  JOIN: 'join',
  DELTA_JOIN: 'delta-join',
  REJOIN: 'rejoin',
  LEAVE: 'leave',
  DELTA_LEAVE: 'delta-leave',
  PUBLISH: 'publish',
  DELTA_PUBLISH: 'delta-publish',
  UNPUBLISH: 'unpublish',
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
  UPLINK_CONNECTION: 'uplink-connection',
  UPLINK_RECONNECTION: 'uplink-reconnection',
  DOWNLINK_CONNECTION: 'downlink-connection',
  DOWNLINK_RECONNECTION: 'downlink-reconnection',
  ON_TRACK: 'ontrack',
  ICE_CONNECTION_STATE: 'iceConnectionState',
  LOCAL_STREAM_INITIALIZE: 'stream-initialize',
  SIGNAL_CONNECTION: 'websocketConnectionState',
  SIGNAL_RECONNECTION: 'websocketReconnectionState',
  UPDATE_STREAM: 'update-stream',
  RECOVER_LOCAL_AUDIO_TRACK: 'recover-local-audio-track',
  RECOVER_LOCAL_VIDEO_TRACK: 'recover-local-video-track',
  RECOVER_SUBSCRIPTION: 'recover-subscription',
  START_MIX_TRANSCODE: 'start-mix-transcode',
  STOP_MIX_TRANSCODE: 'stop-mix-transcode',
  PLAYER_ERROR: 'player-error',
  SCHEDULE: 'schedule',
  LOAD_WORKLET: 'load-worklet',
  VIDEO_FROZEN_COUNT: 'videoFrozenCount',
  GET_USER_MEDIA_RETRY: 'getUserMedia-retry',
  VIDEO_ENCODE_FAILED_DURING_CALL: 'video-encode-failed-during-call',
  VIDEO_ENCODE_RESUME_DURING_CALL: 'video-encode-resume-during-call',
  AUDIO_ENCODE_FAILED_DURING_CALL: 'audio-encode-failed-during-call',
  AUDIO_ENCODE_RESUME_DURING_CALL: 'audio-encode-resume-during-call',
  VIDEO_DECODE_FAILED_DURING_CALL: 'video-decode-failed-during-call',
  VIDEO_DECODE_RESUME_DURING_CALL: 'video-decode-resume-during-call',
  AUDIO_DECODE_FAILED_DURING_CALL: 'audio-decode-failed-during-call',
  AUDIO_DECODE_RESUME_DURING_CALL: 'audio-decode-resume-during-call',
  VIDEO_HARDWARE_DECODE_FAILED: 'video-hardware-decode-failed',
  VIDEO_HARDWARE_DECODE_RESUME: 'video-hardware-decode-resume',
  VIDEO_FRAME_ASSEMBLE_FAILED_DURING_CALL: 'video-frame-assemble-failed-during-call',
  VIDEO_FRAME_ASSEMBLE_RESUME_DURING_CALL: 'video-frame-assemble-resume-during-call'
};

// 定时同步用户列表的时间间隔
export const SYNC_USER_LIST_INTERVAL = 10000;

// update offer 超时间隔
export const UPDATE_OFFER_TIMEOUT = 10000;
export const EXCHANGE_SDP_TIMEOUT = 10000;

export const SDP_SEMANTICS_UNIFIED_PLAN = 'unified-plan';
export const SDP_SEMANTICS_PLAN_B = 'plan-b';

// 基础类型枚举

export const NOT_SUPPORTED_H264 = 1028;
export const enum LOCAL_STREAM_PUBLISH_STATE {
  UNPUBLISH = -1,
  PUBLISHING = 0,
  PUBLISHED = 1,
}

// 数据流卡顿 500 ms
export const DATA_FREEZE_TIMING = 500;

// 渲染卡顿 1000 ms
export const RENDER_FREEZE_TIMING = 1000;

export const STREAM_TYPE_BIG = NAME.BIG;
export const STREAM_TYPE_SMALL = NAME.SMALL;

// peerConnection 连接超时时间
export const PEERCONNECTION_CONNECTING_TIMEOUT = 10 * 1000;
// 请求信令调度的 url

export const SCHEDULE_DOMAIN = {
  MAIN: 'schedule.cloud-rtc.com',
  BACKUP: 'schedule.cloud-rtc.net',
  MAIN_OVERSEA: 'schedule.rtc-web.com',
  BACKUP_OVERSEA: 'schedule.rtc-web.io',
  MAIN_OVERSEA_BACKUP: 'intl-schedule.cloud-rtc.com'
};
export const SCHEDULE_TIMEOUT = 2000;

export const CLASS_NAME = {
  TRTC: 'TRTC',
  CLIENT: 'Client',
  LOCAL_STREAM: 'LocalStream',
  REMOTE_STREAM: 'RemoteStream',
  STREAM: 'Stream'
};

export const PAUSED_RETRY_COUNT = 5;
export const MICROPHONE_DEFAULT = 'default';
export const SPEAKER_DEFAULT = MICROPHONE_DEFAULT;
export const MICROPHONE_COMMUNICATIONS = 'communications';

export const LOG_LEVEL_NAME = Object.keys(LOG_LEVEL);

// https://iwiki.woa.com/pages/viewpage.action?pageId=1109917349 远端用户离开通知
// "reason": int, 0-正常退出； 1-超时推出； 2-被踢； 3-角色切换
export const PEER_LEAVE_REASON = ['normal leave', 'timeout leave', 'kick', 'role change'];


// 订阅小流不成功的 retry 次数
export const SUBSCRIBE_SMALL_RETRY_COUNT = 10;

// 两次恢复采集的间隔时长
export const RECOVER_CAPTURE_INTERVAL = 2000;

export const CAPABILITIES_KEYS = ['width', 'height', 'frameRate', 'facingMode', 'sampleRate', 'sampleSize', 'channelCount', 'deviceId', 'min', 'max'];

// NETWORK_QUALITY和STATISTICS事件抛出的RTT最大值
export const MAX_RTT = 10 * 1000;

export const ASR_ROBOT_FROM_TYPE = 14;

// WebGL2 上下文创建属性，用于视频渲染和虚拟背景等需要 WebGL2 的功能
export const WEBGL_ATTRIBUTES = {
  alpha: true,
  antialias: false,
  premultipliedAlpha: false,
  preserveDrawingBuffer: false,
  depth: false,
  stencil: false,
  failIfMajorPerformanceCaveat: true,
  powerPreference: 'low-power'
};
